<template>
    <div class="moment-manage wrapper" v-loading="loading">
        <proTitle></proTitle>

        <el-empty v-if="!loading && !enabledList.length" description="暂无已启用的精彩瞬间，请先在「精彩瞬间设置」中启用"></el-empty>

        <template v-else-if="enabledList.length">
            <div class="log-cards-wrap" ref="logCardsWrap" @wheel.prevent="onCardsWheel">
                <div class="log-cards" ref="logCards" :style="logCardsStyle">
                    <div class="log-card" v-for="item in enabledList" :key="item.id"
                        :class="{ 'is-active': item.id === currentId }"
                        @click="selectTemplate(item.id)">
                        <div class="log-card-row1">
                            <span class="log-card-name" :title="(item.name || '').length > 6 ? item.name : ''">{{ truncName(item.name) }}</span>
                        </div>
                        <div class="log-card-row2">作答 {{ getItemDayCount(item) }} 天</div>
                        <div class="log-card-row3">{{ formatGroupText(item) }}</div>
                        <div class="log-card-bottom">
                            <span class="log-card-date" :title="formatFullTime(item.updateAt)">{{ formatShortDate(item.updateAt) }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="date-bar-wrap" ref="dateBarWrap" @wheel.prevent="onDateBarWheel" v-if="openedDays.length">
                <div class="date-bar" ref="dateBar">
                    <div class="date-bar-item" v-for="day in openedDays" :key="day.id"
                        :class="{ 'is-active': day.id === currentDayId }"
                        @click="selectDay(day)">
                        <div class="date-bar-date">{{ formatDateLabel(day.momentDate) }}</div>
                        <div class="date-bar-week">
                            <span>{{ weekdayLabel(day.momentDate) }}</span>
                            <span class="date-bar-status" :class="dayStatusClass(day)">{{ dayStatusText(day) }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="stat-grid">
                <div class="stat-card">
                    <div class="stat-value">{{ dayMomentCount }}</div>
                    <div class="stat-label">当日瞬间数</div>
                </div>
                <div class="stat-card">
                    <div class="stat-value">{{ mediaCount }}</div>
                    <div class="stat-label">当日媒体数</div>
                </div>
                <div class="stat-card">
                    <div class="stat-value">{{ featuredUserCount }}</div>
                    <div class="stat-label">已精选</div>
                </div>
                <div class="stat-card">
                    <div class="stat-value">{{ submittedCount }}</div>
                    <div class="stat-label">提交人数</div>
                </div>
            </div>

            <div class="filter-seg">
                <button type="button" class="filter-seg-btn" :class="{ 'is-active': filter === 'all' }" @click="setFilter('all')">全部</button>
                <button type="button" class="filter-seg-btn" :class="{ 'is-active': filter === 'featured' }" @click="setFilter('featured')">已精选</button>
                <button type="button" class="filter-seg-btn" :class="{ 'is-active': filter === 'normal' }" @click="setFilter('normal')">未精选</button>
            </div>

            <div class="split">
                <div class="pane detail-pane">
                    <div class="pane-title">提交详情</div>
                    <div class="work-card" v-if="selectedUser && currentFile">
                        <div class="work-cover" @click="openPreview">
                            <img v-if="currentFile.mediaType === 1" :src="currentFile.ossUrl" alt="" />
                            <video v-else :src="currentFile.ossUrl" muted preload="metadata"></video>
                            <span class="work-play" v-if="currentFile.mediaType === 2">▶</span>
                            <button type="button" class="work-nav prev" :disabled="fileIndex <= 0"
                                v-if="visibleFiles.length > 1" @click.stop="shiftFile(-1)">‹</button>
                            <button type="button" class="work-nav next" :disabled="fileIndex >= visibleFiles.length - 1"
                                v-if="visibleFiles.length > 1" @click.stop="shiftFile(1)">›</button>
                            <span class="work-pager">{{ fileIndex + 1 }}/{{ visibleFiles.length }}</span>
                        </div>
                        <div class="work-info">
                            <div class="work-info-row">
                                <div class="work-name" @mouseenter="onMaybeTitle">{{ currentFile.fileName }}</div>
                                <button type="button" class="work-star" :class="{ 'is-on': isFileFeatured(currentFile) }"
                                    @click.stop="askFeatured(currentFile)">
                                    <i :class="isFileFeatured(currentFile) ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
                                    <span>{{ isFileFeatured(currentFile) ? '已精选' : '未精选' }}</span>
                                </button>
                            </div>
                            <div class="work-caption" v-if="fileCaption(currentFile)" @mouseenter="onMaybeTitle">{{ fileCaption(currentFile) }}</div>
                        </div>
                    </div>
                    <div class="empty-block" v-else-if="selectedUser">暂无作品</div>
                    <div class="empty-block" v-else>请从右侧选择用户查看提交详情</div>
                </div>
                <submit-user-pane
                    :users="filteredUsers"
                    :selected-key="selectedKey"
                    status-mode="featured"
                    @select="onSelectUser"
                />
            </div>
        </template>

        <div class="hl-preview" v-if="previewVisible" @click.self="previewVisible = false">
            <button type="button" class="hl-close" @click="previewVisible = false">✕</button>
            <button type="button" class="hl-nav prev" v-if="fileIndex > 0" @click.stop="shiftFile(-1)">‹</button>
            <div class="hl-stage" @click.stop>
                <div class="hl-media">
                    <img v-if="currentFile && currentFile.mediaType === 1" :src="currentFile.ossUrl" alt="" />
                    <video v-else-if="currentFile" :src="currentFile.ossUrl" controls autoplay></video>
                    <span class="hl-badge" v-if="currentFile && isFileFeatured(currentFile)">精选</span>
                </div>
                <div class="hl-caption">
                    <div class="hl-caption-text">{{ currentFile && fileCaption(currentFile) }}</div>
                    <div class="hl-caption-meta">
                        <span>{{ selectedUser && selectedUser.userName }} · {{ currentFile && currentFile.fileName }}</span>
                        <span>{{ fileIndex + 1 }} / {{ visibleFiles.length }}</span>
                    </div>
                </div>
            </div>
            <button type="button" class="hl-nav next" v-if="fileIndex < visibleFiles.length - 1"
                @click.stop="shiftFile(1)">›</button>
        </div>

        <el-dialog
            :title="featuredDialog.title"
            :visible.sync="featuredDialog.visible"
            width="400px"
            custom-class="log-action-dialog"
            :show-close="true"
            :close-on-click-modal="false"
            append-to-body>
            <div class="action-dialog-body">
                <div class="action-dialog-question">{{ featuredDialog.text }}</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="featuredDialog.visible = false">取消</el-button>
                <el-button type="primary" :loading="featuredSaving" @click="confirmFeatured">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import SubmitUserPane from './components/submit-user-pane.vue';
    import {
        isApiSuccess,
        apiMsg,
        apiData,
        displayGroupNames,
        formatDateLabel,
        weekdayLabel,
        todayKey,
        parseDateTime,
        isAllGroups,
        overviewUserKey,
        buildMomentUsers,
        isMomentFileFeatured,
        filterFeaturedUsers,
        pickDefaultFeaturedUserKey,
        scrollDateChipToCenter,
    } from './log-moment-shared.js';

    export default {
        components: { SubmitUserPane },
        data() {
            return {
                loading: false,
                list: [],
                currentId: null,
                currentDayId: null,
                overview: null,
                filter: 'all',
                selectedKey: null,
                fileIndex: 0,
                previewVisible: false,
                featuredSaving: false,
                featuredTouched: false,
                featuredDialog: {
                    visible: false,
                    title: '',
                    text: '',
                    file: null,
                    next: 0,
                },
                today: todayKey(),
            };
        },
        computed: {
            ...mapState({
                currentProject: (state) => state.user.currentProject,
            }),
            projectId() {
                return this.currentProject && this.currentProject.id;
            },
            enabledList() {
                return (this.list || []).filter((item) => item.status === 1);
            },
            currentItem() {
                return this.enabledList.find((item) => item.id === this.currentId) || null;
            },
            currentDays() {
                return ((this.currentItem && this.currentItem.days) || []).slice().sort((a, b) => String(a.momentDate).localeCompare(String(b.momentDate)));
            },
            openedDays() {
                return this.currentDays.filter((d) => this.isDayOpened(d));
            },
            fillList() {
                return buildMomentUsers(this.overview);
            },
            filteredUsers() {
                return filterFeaturedUsers(this.fillList, this.filter);
            },
            selectedUser() {
                return this.filteredUsers.find((u) => overviewUserKey(u) === this.selectedKey) || null;
            },
            visibleFiles() {
                let files = (this.selectedUser && this.selectedUser.files) || [];
                if (this.filter === 'featured') return files.filter(isMomentFileFeatured);
                if (this.filter === 'normal') return files.filter((f) => !isMomentFileFeatured(f));
                return files;
            },
            currentFile() {
                return this.visibleFiles[this.fileIndex] || null;
            },
            dayMomentCount() {
                return this.fillList.length;
            },
            mediaCount() {
                return this.fillList.reduce((sum, u) => sum + ((u.files || []).length), 0);
            },
            featuredUserCount() {
                if (!this.featuredTouched && this.overview && this.overview.featuredCount != null) {
                    return this.overview.featuredCount;
                }
                return this.fillList.filter((u) => (u.files || []).some(isMomentFileFeatured)).length;
            },
            submittedCount() {
                if (!this.overview) return 0;
                return this.overview.submittedCount != null ? this.overview.submittedCount : 0;
            },
            logCardsStyle() {
                let count = this.enabledList.length;
                if (count <= 4) return {};
                return { width: (count * 25) + '%' };
            },
        },
        watch: {
            projectId: {
                immediate: true,
                handler(id) {
                    if (id) this.loadList();
                },
            },
            filter() {
                this.fileIndex = 0;
                this.previewVisible = false;
                this.autoSelectUser();
            },
            filteredUsers() {
                if (this.selectedKey && !this.filteredUsers.some((u) => overviewUserKey(u) === this.selectedKey)) {
                    this.autoSelectUser();
                }
                if (this.fileIndex >= this.visibleFiles.length) this.fileIndex = 0;
            },
        },
        methods: {
            displayGroupNames,
            formatDateLabel,
            weekdayLabel,
            isFileFeatured: isMomentFileFeatured,
            getItemDayCount(item) {
                if (item.dates && item.dates.length) return item.dates.length;
                return (item.days || []).length;
            },
            truncName(name) {
                if (!name) return '未命名';
                return name.length > 6 ? name.substring(0, 6) + '...' : name;
            },
            formatGroupText(item) {
                let names = displayGroupNames(item);
                if (!names || !names.length) return '未配置用户组';
                if (isAllGroups(item && item.userGroupIds, null, item)) return '适用全部学员';
                if (names.length === 1) return `适用${names[0]}`;
                if (names.length === 2) return `适用${names[0]}、${names[1]}`;
                return `适用${names[0]}等${names.length}个用户组`;
            },
            formatShortDate(val) {
                if (!val) return '-';
                let s = String(val);
                if (s.length >= 10) return s.substring(0, 10);
                return s;
            },
            formatFullTime(val) {
                if (!val) return '-';
                let s = String(val);
                if (s.length >= 16) return s.substring(0, 16);
                return s;
            },
            fileCaption(file) {
                if (!file) return '';
                return file.description || file.caption || (this.selectedUser && this.selectedUser.content) || '';
            },
            realFileIndex(file) {
                let files = (this.selectedUser && this.selectedUser.files) || [];
                let idx = files.findIndex((f) => f.id === file.id);
                return idx < 0 ? 1 : idx + 1;
            },
            onMaybeTitle(e) {
                let el = e.currentTarget;
                if (el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight) {
                    el.title = (el.textContent || '').trim();
                } else {
                    el.title = '';
                }
            },
            isTemplateOpened(item) {
                if (!item) return true;
                let start = parseDateTime(item.submitStart);
                if (!start) return true;
                return new Date() >= start;
            },
            isDayOpened(day) {
                if (!this.currentItem || !day) return false;
                if (!this.isTemplateOpened(this.currentItem)) return false;
                return day.momentDate <= this.today;
            },
            dayStatusText(day) {
                if (day.momentDate === this.today) return '今日';
                return '已开启';
            },
            dayStatusClass(day) {
                return day.momentDate === this.today ? 'is-today' : 'is-opened';
            },
            defaultDayId() {
                let opened = this.openedDays;
                if (!opened.length) return null;
                let todayItem = opened.find((d) => d.momentDate === this.today);
                if (todayItem) return todayItem.id;
                return opened[opened.length - 1].id;
            },
            autoSelectUser() {
                this.selectedKey = pickDefaultFeaturedUserKey(this.filteredUsers);
                this.fileIndex = 0;
            },
            setFilter(val) {
                this.filter = val;
            },
            onSelectUser(key) {
                this.selectedKey = key;
                this.fileIndex = 0;
                this.previewVisible = false;
            },
            onCardsWheel(e) {
                let wrap = this.$refs.logCardsWrap;
                if (wrap) wrap.scrollLeft += e.deltaY || e.deltaX;
            },
            onDateBarWheel(e) {
                let wrap = this.$refs.dateBarWrap;
                if (wrap) wrap.scrollLeft += e.deltaY || e.deltaX;
            },
            async loadList() {
                if (!this.projectId) return;
                this.loading = true;
                try {
                    let res = await this.$Api.Moment.getTemplateList({ projectId: this.projectId });
                    if (!isApiSuccess(res)) {
                        this.$message.error(apiMsg(res) || '获取精彩瞬间设置失败');
                        this.list = [];
                        return;
                    }
                    this.list = apiData(res) || [];
                    if (!this.enabledList.length) {
                        this.currentId = null;
                        this.overview = null;
                        return;
                    }
                    if (!this.enabledList.some((x) => x.id === this.currentId)) {
                        this.currentId = this.enabledList[0].id;
                    }
                    await this.ensureDayAndOverview();
                } finally {
                    this.loading = false;
                }
            },
            async selectTemplate(id) {
                this.currentId = id;
                this.filter = 'all';
                this.selectedKey = null;
                this.currentDayId = null;
                this.fileIndex = 0;
                await this.ensureDayAndOverview();
            },
            async ensureDayAndOverview() {
                this.currentDayId = this.defaultDayId();
                if (this.currentDayId) await this.fetchOverview();
                else this.overview = null;
                this.scrollActiveDateChip();
            },
            async selectDay(day) {
                this.currentDayId = day.id;
                this.selectedKey = null;
                this.fileIndex = 0;
                this.scrollActiveDateChip();
                await this.fetchOverview();
            },
            scrollActiveDateChip() {
                this.$nextTick(() => {
                    scrollDateChipToCenter(this.$refs.dateBarWrap, '.date-bar-item.is-active');
                });
            },
            async fetchOverview() {
                if (!this.currentDayId) return;
                this.loading = true;
                try {
                    let res = await this.$Api.Moment.getDayOverview({ dayId: this.currentDayId });
                    if (!isApiSuccess(res)) {
                        this.$message.error(apiMsg(res) || '获取提交概况失败');
                        this.overview = null;
                        return;
                    }
                    this.overview = apiData(res) || {};
                    this.featuredTouched = false;
                    this.autoSelectUser();
                } finally {
                    this.loading = false;
                }
            },
            shiftFile(delta) {
                let next = this.fileIndex + delta;
                if (next < 0 || next >= this.visibleFiles.length) return;
                this.fileIndex = next;
            },
            openPreview() {
                if (!this.currentFile) return;
                this.previewVisible = true;
            },
            askFeatured(file) {
                if (!file || !this.selectedUser) return;
                let next = isMomentFileFeatured(file) ? 0 : 1;
                let n = this.realFileIndex(file);
                let name = this.selectedUser.userName || '未命名';
                this.featuredDialog = {
                    visible: true,
                    file,
                    next,
                    title: next === 1 ? '精选' : '撤销精选',
                    text: next === 1
                        ? `确定将「${name}」的第 ${n} 张作品设为精选吗？`
                        : `确定将「${name}」的第 ${n} 张作品撤销精选吗？`,
                };
            },
            async confirmFeatured() {
                let file = this.featuredDialog.file;
                let next = this.featuredDialog.next;
                if (!file) return;
                this.featuredSaving = true;
                try {
                    let res = await this.$Api.Moment.setFileFeatured({
                        id: file.id,
                        isFeatured: next,
                    });
                    if (isApiSuccess(res)) {
                        this.$set(file, 'isFeatured', next);
                        if (this.selectedUser) {
                            this.$set(this.selectedUser, 'hasFeatured', (this.selectedUser.files || []).some(isMomentFileFeatured));
                        }
                        this.featuredTouched = true;
                        this.$message.success(next === 1 ? '已精选该作品' : '已取消精选');
                        this.featuredDialog.visible = false;
                    } else {
                        this.$message.error(apiMsg(res) || '操作失败');
                    }
                } catch (e) {
                    this.$message.error('操作失败');
                } finally {
                    this.featuredSaving = false;
                }
            },
        },
    };
</script>

<style lang="less" scoped>
    @selected-blue: #3A7BD5;
    @selected-border: #8BB8F0;
    @border-color: #EBEEF5;
    @pane-h: 640px;
    @pane-title-h: 47px;

    .moment-manage {
        padding: 20px 25px;
        box-sizing: border-box;
    }

    .log-cards-wrap {
        margin-bottom: 16px;
        overflow-x: auto;
        overflow-y: hidden;
        scrollbar-width: thin;
        scrollbar-color: #D5D8DC transparent;

        &::-webkit-scrollbar {
            height: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: #D5D8DC;
            border-radius: 2px;
        }
    }

    .log-cards {
        display: flex;
        gap: 0;
        min-width: 100%;
    }

    .log-card {
        flex: 1 0 0;
        min-width: 0;
        background: #fff;
        border: 1px solid @border-color;
        border-radius: 8px;
        padding: 14px 16px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        gap: 6px;
        position: relative;
        transition: transform 0.15s, box-shadow 0.15s, border-color 0.15s;
        margin-right: 10px;

        &:last-child {
            margin-right: 0;
        }

        &:hover:not(.is-active) {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        &.is-active {
            border-color: @selected-border;
            border-left: 3px solid @selected-blue;
            box-shadow: 0 0 0 3px rgba(58, 123, 213, 0.1);

            .log-card-name {
                color: @selected-blue;
            }
        }
    }

    .log-card-row1 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
    }

    .log-card-name {
        font-size: 14px;
        font-weight: 600;
        color: #1F2A37;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        min-width: 0;
        flex: 1;
    }

    .log-card-row2,
    .log-card-row3 {
        font-size: 12px;
        color: #8B95A1;
        line-height: 18px;
    }

    .log-card-bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: auto;
    }

    .log-card-date {
        font-size: 12px;
        color: #B0B6BF;
    }

    .date-bar-wrap {
        margin-bottom: 16px;
        overflow-x: auto;
        overflow-y: hidden;
        scrollbar-width: thin;
        scrollbar-color: #D5D8DC transparent;

        &::-webkit-scrollbar {
            height: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: #D5D8DC;
            border-radius: 2px;
        }
    }

    .date-bar {
        display: flex;
        min-width: 100%;
    }

    .date-bar-item {
        flex: 1 0 calc(100% / 7);
        min-width: calc(100% / 7);
        box-sizing: border-box;
        text-align: center;
        padding: 10px 8px;
        cursor: pointer;
        background: #fff;
        border: 1px solid @border-color;
        border-radius: 8px;
        margin-right: 8px;
        transition: border-color 0.15s, box-shadow 0.15s;

        &:last-child {
            margin-right: 0;
        }

        &:hover:not(.is-active) {
            border-color: #C0C4CC;
        }

        &.is-active {
            border-color: @selected-border;
            border-left: 3px solid @selected-blue;
            box-shadow: 0 0 0 3px rgba(58, 123, 213, 0.1);

            .date-bar-date {
                color: @selected-blue;
            }
        }
    }

    .date-bar-date {
        font-size: 13px;
        font-weight: 600;
        color: #1F2A37;
        line-height: 20px;
    }

    .date-bar-week {
        font-size: 12px;
        color: #8B95A1;
        margin-top: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
    }

    .date-bar-status {
        display: inline-block;
        padding: 0 6px;
        border-radius: 8px;
        font-size: 11px;
        line-height: 18px;

        &.is-today {
            background: #F3F8FF;
            color: @selected-blue;
        }

        &.is-opened {
            background: #EEF8F0;
            color: #3D9A5A;
        }
    }

    .stat-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 12px;
        margin-bottom: 16px;
    }

    .stat-card {
        background: #fff;
        border: 1px solid @border-color;
        border-radius: 8px;
        padding: 16px 20px;
        text-align: center;
    }

    .stat-value {
        font-size: 28px;
        font-weight: 700;
        color: #1F2A37;
    }

    .stat-label {
        font-size: 13px;
        color: #8B95A1;
        margin-top: 4px;
    }

    .filter-seg {
        display: inline-flex;
        padding: 3px;
        background: #F0F2F5;
        border-radius: 8px;
        gap: 2px;
        margin-bottom: 16px;
    }

    .filter-seg-btn {
        padding: 6px 16px;
        border: none;
        border-radius: 6px;
        background: transparent;
        font-size: 13px;
        font-weight: 500;
        color: #606266;
        cursor: pointer;
        font-family: inherit;

        &.is-active {
            background: #fff;
            color: @selected-blue;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
        }
    }

    .split {
        display: grid;
        grid-template-columns: 1fr 300px;
        gap: 16px;
        align-items: stretch;

        /deep/ .user-pane {
            height: @pane-h;
        }
    }

    .pane {
        background: #fff;
        border: 1px solid @border-color;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        min-height: 0;
        overflow: hidden;
        height: @pane-h;
    }

    .pane-title {
        height: @pane-title-h;
        padding: 0 16px;
        font-size: 14px;
        font-weight: 600;
        border-bottom: 1px solid @border-color;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-shrink: 0;
    }

    .work-card {
        flex: 1;
        min-height: 0;
        margin: 12px 16px 16px;
        border: 1px solid @border-color;
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        background: #fff;
    }

    .work-cover {
        position: relative;
        flex: 1;
        min-height: 0;
        background: #F4F6F8;
        cursor: zoom-in;

        img,
        video {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            object-fit: contain;
            display: block;
        }
    }

    .work-play {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.45);
        color: #fff;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: none;
        z-index: 1;
    }

    .work-nav {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 2;
        width: 52px;
        height: 52px;
        border: none;
        border-radius: 50%;
        background: #fff;
        color: @selected-blue;
        font-size: 24px;
        line-height: 1;
        cursor: pointer;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);

        &.prev {
            left: 12px;
        }

        &.next {
            right: 12px;
        }

        &:hover:not(:disabled) {
            background: @selected-blue;
            color: #fff;
        }

        &:disabled {
            color: #C0C4CC;
            background: #fff;
            cursor: not-allowed;
            box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
        }
    }

    .work-pager {
        position: absolute;
        right: 12px;
        bottom: 12px;
        z-index: 2;
        background: rgba(0, 0, 0, 0.55);
        color: #fff;
        font-size: 12px;
        line-height: 18px;
        padding: 2px 8px;
        border-radius: 10px;
        pointer-events: none;
    }

    .work-info {
        flex-shrink: 0;
        padding: 12px 16px;
        border-top: 1px solid @border-color;
        background: #fff;
    }

    .work-info-row {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .work-name {
        flex: 1;
        min-width: 0;
        font-size: 13px;
        font-weight: 600;
        color: #303133;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .work-star {
        flex-shrink: 0;
        display: inline-flex;
        align-items: center;
        gap: 4px;
        border: none;
        background: transparent;
        padding: 0;
        color: #8B95A1;
        font-size: 13px;
        cursor: pointer;
        white-space: nowrap;
        font-family: inherit;

        i {
            font-size: 16px;
        }

        &.is-on i {
            color: #F7BA2A;
        }
    }

    .work-caption {
        margin-top: 6px;
        font-size: 13px;
        color: #606266;
        line-height: 1.5;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .empty-block {
        min-height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #8B95A1;
        font-size: 13px;
        text-align: center;
        padding: 24px;
        flex: 1;
    }

    .action-dialog-body {
        text-align: center;
        padding: 12px 0 4px;
    }

    .action-dialog-question {
        font-size: 15px;
        color: #1F2A37;
        line-height: 1.7;
    }

    .hl-preview {
        position: fixed;
        inset: 0;
        z-index: 3000;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.82);
        padding: 40px 88px;
    }

    .hl-close {
        position: absolute;
        top: 16px;
        right: 16px;
        width: 36px;
        height: 36px;
        border: none;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.14);
        color: #fff;
        font-size: 18px;
        cursor: pointer;
    }

    .hl-stage {
        width: 100%;
        max-width: 920px;
        display: flex;
        flex-direction: column;
        gap: 12px;
        align-items: center;
    }

    .hl-media {
        position: relative;
        max-width: 100%;
        max-height: calc(100vh - 220px);
        background: #111;
        border-radius: 8px;
        overflow: hidden;

        img,
        video {
            display: block;
            max-width: 100%;
            max-height: calc(100vh - 220px);
        }
    }

    .hl-badge {
        position: absolute;
        top: 12px;
        right: 12px;
        background: #67C23A;
        color: #fff;
        font-size: 12px;
        padding: 4px 10px;
        border-radius: 12px;
    }

    .hl-caption {
        width: 100%;
        background: rgba(255, 255, 255, 0.96);
        border-radius: 8px;
        padding: 12px 16px;
    }

    .hl-caption-text {
        font-size: 14px;
        line-height: 1.65;
        margin-bottom: 6px;
        white-space: pre-wrap;
    }

    .hl-caption-meta {
        font-size: 12px;
        color: #909399;
        display: flex;
        justify-content: space-between;
    }

    .hl-nav {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        min-width: 44px;
        height: 44px;
        border: none;
        background: rgba(255, 255, 255, 0.16);
        color: #fff;
        font-size: 22px;
        cursor: pointer;
        border-radius: 8px;

        &.prev {
            left: 24px;
        }

        &.next {
            right: 24px;
        }
    }

    @media (max-width: 960px) {
        .split {
            grid-template-columns: 1fr;
        }

        .stat-grid {
            grid-template-columns: 1fr 1fr;
        }
    }
</style>

<style lang="less">
    .log-action-dialog {
        border-radius: 12px;
        overflow: hidden;

        .el-dialog__header {
            padding: 12px 16px 0;

            .el-dialog__headerbtn {
                top: 12px;
                right: 12px;
            }
        }

        .el-dialog__body {
            padding: 8px 24px 16px;
        }

        .el-dialog__footer {
            padding: 8px 24px 20px;
            text-align: center;
        }
    }
</style>
